module.exports = __webpack_public_path__ + "static/img/polling.47c8d3a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/polling.png
// module id = RlLD
// module chunks = 1